import { create } from "zustand";
import { persist } from "zustand/middleware";

interface AddressesStore {
  // Modal States
  isDeleteAddressDialogOpen: boolean;
  isEditAddressDialogOpen: boolean;
  editingAddressId: string | null;
  deletingAddressId: string | null;

  // Modal Actions
  openDeleteAddressDialog: (addressId: string) => void;
  closeDeleteAddressDialog: () => void;
  openEditAddressDialog: (addressId: string) => void;
  closeEditAddressDialog: () => void;

  // Reset
  reset: () => void;
}

const initialState = {
  isDeleteAddressDialogOpen: false,
  isEditAddressDialogOpen: false,
  editingAddressId: null,
  deletingAddressId: null,
};

export const useAddressesStore = create<AddressesStore>()(
  persist(
    (set) => ({
      ...initialState,

      // Modal Actions
      openDeleteAddressDialog: (addressId) => {
        set({
          isDeleteAddressDialogOpen: true,
          deletingAddressId: addressId,
        });
      },

      closeDeleteAddressDialog: () => {
        set({
          isDeleteAddressDialogOpen: false,
          deletingAddressId: null,
        });
      },

      openEditAddressDialog: (addressId) => {
        set({
          isEditAddressDialogOpen: true,
          editingAddressId: addressId,
        });
      },

      closeEditAddressDialog: () => {
        set({
          isEditAddressDialogOpen: false,
          editingAddressId: null,
        });
      },

      // Reset
      reset: () => {
        set(initialState);
      },
    }),
    {
      name: "addresses-storage",
      partialize: () => ({}), // Don't persist modal states
    }
  )
);
